// deck.gl-community
// SPDX-License-Identifier: MIT
// Copyright (c) vis.gl contributors
import { EventEmitter } from 'eventemitter3';
import { v4 } from 'uuid';
export class NebulaLayer extends EventEmitter {
    getData;
    toNebulaFeature;
    id;
    helperLayers;
    // flags
    usesMapEvents = false;
    enablePicking = false;
    enableSelection = false;
    //
    constructor({ getData, on, toNebulaFeature }) {
        super();
        this.id = v4();
        this.getData = getData;
        this.toNebulaFeature = toNebulaFeature;
        this.helperLayers = [];
        if (on) {
            Object.keys(on).forEach((key) => this.on(key, on[key]));
        }
    }
    render(config) {
        return null;
    }
}
//# sourceMappingURL=nebula-layer.js.map